/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React base styles
import borders from '../../borders';
import colors from '../../colors';

// Soft UI Dashboard PRO React helper functions
import pxToRem from '../../../functions/pxToRem';
import linearGradient from '../../../functions/linearGradient';
import { grey } from '@mui/material/colors';

const { borderWidth } = borders;
const { transparent, gradients, info } = colors;

const tickSvg = `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e")`;

export default {
    styleOverrides: {
        root: {
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            width: pxToRem(20),
            height: pxToRem(20),
            marginRight: pxToRem(6),
            padding: 0,
            color: transparent.main,
            border: `${borderWidth[1]} solid ${grey[800]}`,
            borderRadius: pxToRem(5.6),
            transition: 'all 250ms ease',

            '&:hover': {
                backgroundColor: transparent.main,
            },

            '& .MuiSvgIcon-root': {
                fill: transparent.main,
            },

            '&.Mui-focusVisible': {
                border: `${borderWidth[2]} solid ${info.main} !important`,
            },
            '&.Mui-disabled': {
                opacity: '0.3 !important',
            },
        },

        colorPrimary: {
            backgroundColor: transparent.main,

            '&.Mui-checked': {
                backgroundImage: `${tickSvg}, ${linearGradient(
                    gradients.dark.main,
                    gradients.dark.state,
                )}`,
                borderColor: gradients.dark.main,
            },

            '&:hover': {
                backgroundColor: transparent.main,
            },
        },

        colorSecondary: {
            backgroundColor: transparent.main,

            '&.Mui-checked': {
                backgroundImage: `${tickSvg}, ${linearGradient(
                    gradients.dark.main,
                    gradients.dark.state,
                )}`,
                borderColor: gradients.dark.main,
            },

            '&:hover': {
                backgroundColor: transparent.main,
            },
        },

        colorAction: {
            backgroundColor: transparent.main,

            '&.Mui-checked': {
                backgroundImage: `${tickSvg}, ${linearGradient(
                    colors.action.main,
                    colors.action.main,
                )}`,
                borderColor: colors.action.main,
            },

            '&:hover': {
                backgroundColor: transparent.main,
            },
        },
    },
};
